import { Container, Row, Col, Text } from '@qonsoll/react-design'
import { useGetApplicationPlatform } from '../../hooks'
import PropTypes from 'prop-types'
import { Spinner } from 'components'
import { useTranslations } from 'contexts/Translation'

export default function ApplicationPlatform(props) {
  const { application } = props

  // [ADDITIONAL_HOOKS]
  const [platform, loading] = useGetApplicationPlatform(application)
  const { t } = useTranslations()

  return (
    <Container>
      <Row noGutters>
        <Col>
          {loading ? (
            <Spinner flex={1} />
          ) : platform ? (
            <Text>{platform?.name}</Text>
          ) : (
            <Text type="secondary" variant="overline">
              {t('No platforms have been added yet')}
            </Text>
          )}
        </Col>
      </Row>
    </Container>
  )
}

ApplicationPlatform.propTypes = {
  application: PropTypes.object.isRequired
}
